import { Tooltip } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { TooltipPlacement } from 'antd/es/tooltip';
import { primaryFont } from '../../../Utils/utilsStyle';

type Props = {
  color?: string;
  width?: string;
  tooltipText: string;
  children?: React.ReactNode;
  placement?: TooltipPlacement;
};

const Span = styled.span<{ width?: string; color?: string }>`
  width: ${(props) => props.width || '100%'};
  background-color: ${(props) => props.color || 'transparent'};
  display: inline-block;
  height: 100%;
  font-family: ${primaryFont};
`;

const CustomTooltip = function CustomTooltip(props: Props) {
  const { color, width, tooltipText, children, placement = 'top' } = props;

  return (
    <Tooltip
      placement={placement}
      className="triggers-bullet-tooltip tooltip-item"
      color="#fff"
      title={tooltipText}
      arrow={false}
      overlayInnerStyle={{
        width: `${width}`,
        whiteSpace: 'wrap',
        maxWidth: 'none',
      }}
    >
      {children || <Span width={width} color={color} />}
    </Tooltip>
  );
};

export default CustomTooltip;